import React from "react"
import { 
    latest as API_URL, 
    host as ROOT_DIR 
} from "../../../config/api";
import { isActiveSlide, positionLeft, panels } from "../../../config/Helpers";
import { Icon } from 'antd';

//Modulos
import General from "./views/General";
import FutureReserves from "./views/FutureReserves";
import AdvanceBooking from "./views/AdvanceBooking";
import FiltersActive from "./../../../components/FiltersActive";
const postUrlLogin = API_URL + "widgets";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            response_request : [],
            request_status   : "hide",
            active_slide: {},
            slides: {},
            slides_component : "",
            moving_touch : 0,
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            panels : panels()    
        }
        this.getResetValues = this.getResetValues.bind(this);
    }
    getResetValues(){
        return {
            response_request : [],
            request_status   : "hide",
            active_slide: {},
            slides_component : "",
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            panels : panels()
        }
    }
    setDefaultValuesModule(){
        let $self = this;
        this.setState({
            response_request : [],
            tab_submodule : 'inactive',
            slides_component : "",
            tab_filters : 'inactive'
        }, $self.props.app.mainRequest())
    }
    activeSlide(slide) {
        this.setState(function (prev) {
            if (prev.activeSlide !== slide.key) {
                return {
                    active_slide: slide
                }
            }
        })
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    componentWillReceiveProps(props) {
        let response    = props.app.state.leadtime_response_request
        this.setState({
            response_request : response,
        })
    }
    render() {
        let request_send = this.props.app.state.leadtime_module.request_send;
        if (this.props.app.state.panel === "lead-time"){
            let panel = "lead-time", 
            panel_dashboards = this.props.app.state.mode_report._dashboards_select,
            self = this,
            panels = this.state.panels;
            
            this.state.slides_component = Object.keys(panels).map((key) => {
                let index = -1;
                if(panels[key].value === panel){
                    let dashboards = panels[key].dashboards;
                    return (Object.keys(dashboards).map((key_aux) => {
                        let dashboard_include = false;
                        if(self.props.app.state.mode_report.status === true && self.props.app.state.mode_report._is_share === true){
                            Object.keys(panel_dashboards).map((key) => {
                                let _decode = JSON.parse(panel_dashboards[key]);
                                if(_decode._dashboard === dashboards[key_aux].value){
                                    dashboard_include = true
                                }
                            })
                        }else{
                            dashboard_include = true
                        }
                        if(dashboard_include === true){
                            index++;
                            if(index === 0 && self.state.active_slide.key === undefined){
                                self.state.active_slide.key = dashboards[key_aux].value
                                self.state.active_slide.index = index
                            }
                            let props = {
                                className : isActiveSlide(self.state.active_slide.key, dashboards[key_aux].value),
                                onClick : () => {
                                    if(request_send !== true && dashboards[key_aux].name !== 'General' || dashboards[key_aux].name === 'General'){
                                        self.activeSlide({ key: dashboards[key_aux].value, index : index})
                                    }
                                    
                                }
                            }
                            return (
                                <div {...props}>
                                    <span className="title">
                                    {
                                        (request_send === true && dashboards[key_aux].name !== 'General') ? 
                                            <Icon type="loading" /> : 
                                            dashboards[key_aux].name
                                    }</span>
                                </div>
                            )
                        }
                    }))
                }
            })
            
            return (
                <div className="layout">
                    <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "lead-time" ? "hide" : "")}>
                        <div className="bkg-stars">
                            <span 
                                className="figure-1"
                                style={{
                                    background : 'url(' + ROOT_DIR + "uploads/" + this.props.app.state.subdomain + "/logo_old.svg" + ') center center no-repeat',
                                    backgroundSize : 300
                                }} 
                            ></span>
                        </div>
                    </div>
                    <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "general", "main-slide")}>
                        <General
                            request_status={this.state.request_status}
                            panel={this.props.app.state.panel}
                            current_slide={this.state.active_slide.key}
                            response_request={this.state.response_request}
                            current_year={this.props.app.state.current_year}
                            past_year={this.props.app.state.past_year}
                            view_results={this.props.app.state.view_results}
                        />
                    </div>
                    <div style={positionLeft(1, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "future_reserves", "main-slide")}>
                        <FutureReserves
                            app={this.props.app}
                            request_status={this.state.request_status}
                            panel={this.props.app.state.panel}
                            current_slide={this.state.active_slide.key}
                            response_request={this.state.response_request}
                            view_results={this.props.app.state.view_results}
                            current_year={this.props.app.state.current_year}
                            past_year={this.props.app.state.past_year}
                        />
                    </div>
                    <div style={positionLeft(2, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "advance_booking", "main-slide")}>
                        <AdvanceBooking
                            app={this.props.app}
                            request_status={this.state.request_status}
                            panel={this.props.app.state.panel}
                            current_slide={this.state.active_slide.key}
                            response_request={this.state.response_request}
                            current_year={this.props.app.state.current_year}
                            past_year={this.props.app.state.past_year}
                            view_results={this.props.app.state.view_results}
                        />
                    </div>
                    <div className={"slide-keys " + (this.props.app.state.panel !== "lead-time" ? "hide" : "") + " " + this.props.app.state.status_sidebar}>
                        <div className="tabs">
                             <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}><Icon type="ellipsis" theme="outlined" /> DASHBOARDS</div>
                             <div className={this.state.tab_filters + this.props.app.hasFilters()} onClick={this.activeFiltersTab.bind(this)}><Icon type="filter" theme="outlined" /> FILTERS</div>
                        </div>
                        <div className={"filters-tab " + this.state.tab_filters}>
                            <FiltersActive 
                                app={this.props.app} 
                                ref={(FiltersActive) => { this._FiltersActive = FiltersActive; }}
                            />
                        </div>
                        <div className={"content-submodules " + this.state.tab_submodule} 
                            children={this.state.slides_component}
                        />
                    </div>
                </div>
            )
        }else{
            return (<div></div>)
        }
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/Layout.js